// installPreloadErrorRecovery wires Vite's `vite:preloadError` event to
// a one-shot hard reload. The race it covers:
//
//   1. User opens the site → fetches index.html from build A, which
//      references chunk hashes like Dashboard-${hashA}.js.
//   2. We deploy build B. The static origin now serves build B's chunks
//      (Dashboard-${hashB}.js), and build A's chunks are gone.
//   3. The user's still-open tab navigates a route, triggering a
//      dynamic import for build A's hash → 404 → React.lazy rejects →
//      ErrorBoundary renders "Something went wrong."
//
// The recovery is just to reload: the fresh index.html points at build
// B's hashes, the chunks load, the SPA boots normally. We do it via
// the Vite event rather than in the ErrorBoundary because the event
// fires *before* React's render-tree crash, so the user often never
// sees the error screen at all.
//
// Loop-guarded: if the reload itself produces another preloadError
// within COOLDOWN_MS, bail out and let the ErrorBoundary's manual
// "Reload page" button take over. Hammering location.reload() against
// a genuinely broken deploy would be worse than the static error UI.

const RELOAD_MARKER = 'luno.chunk-reload-at'
const COOLDOWN_MS = 30_000

export function installPreloadErrorRecovery(): void {
  window.addEventListener('vite:preloadError', () => {
    const last = Number(window.sessionStorage.getItem(RELOAD_MARKER) || '0')
    if (Date.now() - last < COOLDOWN_MS) return
    window.sessionStorage.setItem(RELOAD_MARKER, String(Date.now()))
    window.location.reload()
  })
}
